import CloseIcon from '@mui/icons-material/Close';
import { Button, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';

import Loader from '@/components/Loader';
import copyToClipboard from '@/utils/copyToClipboard';

import useGenerationBody from './useGenerationBody';

const PostGenerationBody = ({ handleClose }: { handleClose: () => void }) => {
  const { listApiKeyState, exportToCsv } = useGenerationBody();

  if (listApiKeyState.status === 'failed') {
    return (
      <>
        <DialogContent>
          <Typography variant='subtitle2'>Error generating ApiKey</Typography>
          <Typography variant='subtitle2'>
            Please contact the General Index support team.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ mr: 3, p: 0, height: 48 }}
            variant='text'
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      </>
    );
  }
  if (listApiKeyState.status === 'loading') {
    return <Loader />;
  }
  return (
    <>
      <DialogContent sx={{ paddingBottom: 3 }}>
        <IconButton
          aria-label='close'
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.primary'
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          paddingBottom='4px'
          variant='subtitle2'
        >
          Your token has been created. You can now retrieve the API token.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          sx={{ mr: 1, height: 48 }}
          variant='outlined'
          onClick={() =>
            copyToClipboard(
              listApiKeyState.apiKeyOutputs.at(-1)?.prefixedRawApiKey ?? '',
              'Api key copied to clipboard!'
            )
          }
        >
          Copy token
        </Button>
        <Button
          sx={{ height: 48 }}
          variant='outlined'
          onClick={exportToCsv}
        >
          Download as CSV file
        </Button>
      </DialogActions>
    </>
  );
};

export default PostGenerationBody;
